import React, { useEffect, useState } from 'react'
import MyPagination from '../../../components/pagination/Pagination';
import TableWithSkeleton from '../../../components/table/TableWithSkeleton';
import { GetCommissionAssignTreeApi } from '../../../api/request/ib/commission';
import { useSelector } from 'react-redux';
import { Input, Spin } from 'antd';
import columns from '../../../columns/ib/CommissionDistribute';

const CommissionDistribute = () => {
    const { userDetails } = useSelector(state => state.user);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [search, setSearch] = useState('');
    const [searchText, setSearchText] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState([]);


    const getCommissionData = async () => {
  try {
    setIsLoading(true);
    let params = {
      PageNumber: page,
      PageSize: pageSize,
      SearchText: searchText,
    };

    const { data } = await GetCommissionAssignTreeApi(
      userDetails?._id,
      new URLSearchParams(params).toString()
    );

    if (data?.success) {
      const tableData = [data?.self, ...data?.data]?.flatMap((user) => {
        const totalRows = user?.accountsList?.reduce(
          (sum, acc) => sum + (acc?.levels?.length || 0),
          0
        );

        return user?.accountsList?.flatMap((account) =>
          account?.levels?.map((levelObj, idx) => ({
            ...user,
            name: `${user?.firstName} ${user?.lastName}`,
            email: user?.email,
            planName: account?.planName,
            groupName: account?.groupName,
            level: levelObj?.level,
            commission: levelObj?.commission,
            referralCode: user?.referralCode,
            affiliateCode: user?.affiliateCode,
            ibType: user?.ibType,
            rowSpan: idx === 0 && account === user?.accountsList?.[0] ? totalRows : 0,
          }))
        );
      });

      setData(tableData);
      setTotalRecord(data?.totalRecords);
    }
    setIsLoading(false);
  } catch (error) {
    setIsLoading(false);
  }
};

    useEffect(() => {
        getCommissionData();
    }, [page, searchText, pageSize]);

    useEffect(() => {
        setPage(1);
    }, [searchText]);

    return (
        <>
            <div className="flex justify-end items-center">
                <Input
                    size="large"
                    style={{ width: 220 }}
                    placeholder="Search"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    onPressEnter={() => setSearchText(search)}
                    prefix={
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                            <path fill-rule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clip-rule="evenodd" />
                        </svg>
                    }
                    suffix={search &&
                        <svg xmlns="http://www.w3.org/2000/svg" onClick={() => { setSearchText(''); setSearch('') }} viewBox="0 0 24 24" fill="#bebebe" className="size-5 cursor-pointer duration-300 hover:fill-[#969595]">
                            <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.72 6.97a.75.75 0 1 0-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 1 0 1.06 1.06L12 13.06l1.72 1.72a.75.75 0 1 0 1.06-1.06L13.06 12l1.72-1.72a.75.75 0 1 0-1.06-1.06L12 10.94l-1.72-1.72Z" clip-rule="evenodd" />
                        </svg>
                    }
                />
            </div>

            <div>
                <div className="border border-gray-200 rounded-xl hover-disabled-table my-6">
                    <TableWithSkeleton 
                        columns={columns} 
                        data={data} 
                        loading={isLoading} 
                        rowKey={(record) => `${record.userId}-${record.planName}`} 
                        rowClassName={(record) => record?.ibType === 'Self' ? 'highlight-row' : ''} 
                    />
                </div>
                <div className='px-4'>
                    <MyPagination total={totalRecord} page={page} setPage={setPage} pageSize={pageSize} setPageSize={setPageSize} />
                </div>
            </div>
        </>
    )
}

export default CommissionDistribute